'use strict';

angular
  .module('webAgro1App')
  .controller('RelatoriosVisitaController', RelatoriosVisitaController);

RelatoriosVisitaController.$inject = [
  '$rootScope',
  'RelatorioVisitaService',
  'LoadingService',
  '$location',
  'Flash',
  'MessagesService'
];

// eslint-disable-next-line max-params, max-lines-per-function
function RelatoriosVisitaController($rootScope, RelatorioVisitaService,
  LoadingService, $location, Flash, MessagesService) {
  const vm = this;

  vm.selectedReports = [];
  vm.allSelected = false;
  vm.gerando = false;
  vm.url = null;
  vm.remove = remove;
  vm.new = newReport;
  vm.gerarVarios = gerarVarios;
  vm.toggleSelections = toggleSelections;
  vm.copiarLink = copiarLink;

  function error(err) {
    vm.gerando = false;
    MessagesService.alert('Ocorreu um erro, tente novamente.');
    LoadingService.hideLoading();
    console.error(err);
  }

  function init() {
    RelatorioVisitaService.list().then(function(relatorios) {
      vm.itens = relatorios.data;
      vm.gerando = false;

      LoadingService.hideLoading();
    })
      .catch(error);
  }

  function checkPermission() {
    if (!$rootScope.permissions.relatorioVisita.canRead) {
      $location.path('/');
      Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
      return;
    }

    return true;
  }

  function remove(item) {
    MessagesService.confirm('Deseja realmente remover o relatório?').then(function() {
      LoadingService.showLoading();
      RelatorioVisitaService.remove(item.id).then(init)
        .catch(error);
    })
      .catch(LoadingService.hideLoading);
  }

  function newReport() {
    $location.path('/relatoriovisitacustomizado');
  }

  const verifyJobProgress = (param) => {
    vm.gerando = true;
    const clear = (intervalo) => {
      vm.gerando = false;
      clearInterval(intervalo);
    };

    const intervalo = setInterval(() => {
      RelatorioVisitaService.download(param).then((response) => {
        const { data } = response;
        const message = JSON.parse(data.message);
        if (data.status === 'complete') {
          vm.url = `${SERVER}/${message.url}`;
          clear(intervalo);
          init();
        }
        if (data.status === 'failed' || data.status === 'interrupted') {
          MessagesService.alert('Ocorreu um erro, tente novamente mais tarde.');
          clear(intervalo);
          init();
        }
      }, () => {
        MessagesService.alert('Ocorreu um erro, tente novamente mais tarde.');
        clear(intervalo);
      });
    }, 15000);
  };

  function gerarVarios() {
    const selectedReportsCompact = _.compact(this.selectedReports);

    if (selectedReportsCompact.length) {
      vm.gerando = true;
      LoadingService.showLoading();
      RelatorioVisitaService.gerarVarios(selectedReportsCompact).then(function(result) {
        // eslint-disable-next-line no-console
        console.info('Iniciando geração de relatórios');
        verifyJobProgress(result);
      })
        .catch(error);
    } else {
      MessagesService.alert('Nenhum relatório foi selecionado');
    }
  }

  function toggleSelections() {
    if (vm.allSelected) {
      vm.selectedReports = vm.itens.map(function(item) {
        return item.id;
      });
    } else {
      vm.selectedReports = [];
    }
  }

  function copiarLink(link) {
    navigator.clipboard.writeText(link);
    Flash.create('success', 'URL do Relatório copiada para área de transferência!', 1000);
  }

  LoadingService.showLoading();
  $rootScope.initialize.then(function() {
    if (checkPermission()) {
      init();
    }
  }).catch(error);
}
